var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArbeidsforhold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 14@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-3",
    cx: 32,
    cy: 32,
    r: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GDPR-Personopplysning-forside",
    transform: "translate(-590.000000, -3222.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(590.000000, 3222.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "spotlight/-gjenstand-"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }), /*#__PURE__*/React.createElement("g", {
    id: "spotlight/-element",
    mask: "url(#mask-2)",
    fillRule: "evenodd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF08-60"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "NAV-Brand/farge/-Dyp-bl\\xE5/-60",
    mask: "url(#mask-4)",
    fill: "#99C2E8"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    points: "0 64 64 64 64 0 0 0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "gjenstander/reise/koffert/H\\xE5ndkoffert-B",
    transform: "translate(13.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.136703,29 L1.86329703,29 C1.51140223,29 1.22580645,28.7055139 1.22580645,28.342665 L1.22580645,13.2660306 C1.22580645,12.9031817 1.51140223,12.6086957 1.86329703,12.6086957 L36.136703,12.6086957 C36.4885978,12.6086957 36.7741935,12.9031817 36.7741935,13.2660306 L36.7741935,28.342665 C36.7741935,28.7055139 36.4885978,29 36.136703,29",
    id: "Fill-13",
    fill: "#593A32"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#333333",
    points: "1.22580645 17.6521739 36.7741935 17.6521739 36.7741935 14.5 1.22580645 14.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9032258,3.15217391 L22.682151,3.15217391 L22.682151,2.24440652 C22.682151,1.74149938 22.3097232,1.33397119 21.849378,1.33397119 L16.1512325,1.33397119 C15.6908873,1.33397119 15.3172384,1.74149938 15.3172384,2.24440652 L15.3172384,3.15217391 L14.0967742,3.15217391 L14.0967742,2.1156783 C14.0967742,0.947119542 14.9631268,0 16.0327883,0 L21.9672117,0 C23.0368732,0 23.9032258,0.947119542 23.9032258,2.1156783 L23.9032258,3.15217391 Z",
    id: "Fill-15",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3712253,16.9322174 C37.7183089,16.9322174 38,16.6497826 38,16.3017826 L38,3.7826087 C38,3.4346087 37.7183089,3.15217391 37.3712253,3.15217391 L0.628774717,3.15217391 C0.281691073,3.15217391 0,3.4346087 0,3.7826087 L0,16.3017826 C0,16.6497826 0.281691073,16.9322174 0.628774717,16.9322174 L37.3712253,16.9322174 Z",
    id: "Fill-16",
    fill: "#723B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1079679,19.5434783 C16.1239119,19.5434783 15.3225806,18.7815185 15.3225806,17.8450351 L15.3225806,16.8282456 C15.3225806,15.8917622 16.1239119,15.1304348 17.1079679,15.1304348 L20.8920321,15.1304348 C21.8767526,15.1304348 22.6774194,15.8917622 22.6774194,16.8282456 L22.6774194,17.8450351 C22.6774194,18.7815185 21.8767526,19.5434783 20.8920321,19.5434783 L17.1079679,19.5434783 Z",
    id: "Fill-11",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9249541,15.7608696 L17.0750459,15.7608696 C16.445786,15.7608696 15.9354839,16.2388554 15.9354839,16.8282657 L15.9354839,17.8462805 C15.9354839,18.4356908 16.445786,18.9130435 17.0750459,18.9130435 L20.9249541,18.9130435 C21.554214,18.9130435 22.0645161,18.4356908 22.0645161,17.8462805 L22.0645161,16.8282657 C22.0645161,16.2388554 21.554214,15.7608696 20.9249541,15.7608696",
    id: "Fill-12",
    fill: "#F79221"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbeidsforhold);
export default __webpack_public_path__ + "static/media/Arbeidsforhold.a0fe736223bb55114b86685eca7a19f8.svg";
export { ForwardRef as ReactComponent };